import {
  GET_LIST_INVOICE_TEMPLATE,
  GET_LIST_INVOICE_TEMPLATE_SUCCESS,
  GET_LIST_INVOICE_TEMPLATE_FAIL,

  GET_LIST_ROOT_INVOICE_TEMPLATE,
  GET_LIST_ROOT_INVOICE_TEMPLATE_SUCCESS,
  GET_LIST_ROOT_INVOICE_TEMPLATE_FAIL,

  CREATE_INVOICE_TEMPLATE,
  CREATE_INVOICE_TEMPLATE_SUCCESS,
  CREATE_INVOICE_TEMPLATE_FAIL,
  RESET_CREATE_INVOICE_TEMPLATE_STATE,

  GET_DETAIL_INVOICE_TEMPLATE,
  GET_DETAIL_INVOICE_TEMPLATE_SUCCESS,
  GET_DETAIL_INVOICE_TEMPLATE_FAIL,

  UPDATE_INVOICE_TEMPLATE,
  UPDATE_INVOICE_TEMPLATE_SUCCESS,
  UPDATE_INVOICE_TEMPLATE_FAIL,

  DELETE_INVOICE_TEMPLATE,
  DELETE_INVOICE_TEMPLATE_SUCCESS,
  DELETE_INVOICE_TEMPLATE_FAIL,

  GET_LIST_INVOICE_TYPE,
  GET_LIST_INVOICE_TYPE_SUCCESS,
  GET_LIST_INVOICE_TYPE_FAIL,
} from "./actionTypes";

// Get list invoice template
export const getListInvoiceTemplate = (params = {}) => ({
  type: GET_LIST_INVOICE_TEMPLATE,
  payload: { params },
});

export const getListInvoiceTemplateSuccess = data => ({
  type: GET_LIST_INVOICE_TEMPLATE_SUCCESS,
  payload: data,
});

export const getListInvoiceTemplateFail = error => ({
  type: GET_LIST_INVOICE_TEMPLATE_FAIL,
  payload: error,
});

// Get list root invoice template
export const getListRootInvoiceTemplate = (params = {}) => ({
  type: GET_LIST_ROOT_INVOICE_TEMPLATE,
  payload: { params },
});

export const getListRootInvoiceTemplateSuccess = data => ({
  type: GET_LIST_ROOT_INVOICE_TEMPLATE_SUCCESS,
  payload: data,
});

export const getListRootInvoiceTemplateFail = error => ({
  type: GET_LIST_ROOT_INVOICE_TEMPLATE_FAIL,
  payload: error,
});

// Create invoice template
export const createInvoiceTemplate = data => ({
  type: CREATE_INVOICE_TEMPLATE,
  payload: data,
});

export const createInvoiceTemplateSuccess = data => ({
  type: CREATE_INVOICE_TEMPLATE_SUCCESS,
  payload: data,
});

export const createInvoiceTemplateFail = error => ({
  type: CREATE_INVOICE_TEMPLATE_FAIL,
  payload: error,
});

export const resetCreateInvoiceTemplateState = () => ({
  type: RESET_CREATE_INVOICE_TEMPLATE_STATE,
})

// Update invoice template
export const updateInvoiceTemplate = (id, data = {}) => ({
  type: UPDATE_INVOICE_TEMPLATE,
  payload: { id, data },
});

export const updateInvoiceTemplateSuccess = data => ({
  type: UPDATE_INVOICE_TEMPLATE_SUCCESS,
  payload: data,
});

export const updateInvoiceTemplateFail = error => ({
  type: UPDATE_INVOICE_TEMPLATE_FAIL,
  payload: error,
});

// Get detail invoice template
export const deleteInvoiceTemplate = id => ({
  type: DELETE_INVOICE_TEMPLATE,
  payload: { id },
});

export const deleteInvoiceTemplateSuccess = data => ({
  type: DELETE_INVOICE_TEMPLATE_SUCCESS,
  payload: data,
});

export const deleteInvoiceTemplateFail = error => ({
  type: DELETE_INVOICE_TEMPLATE_FAIL,
  payload: error,
});

// Get detail invoice template
export const getDetailInvoiceTemplate = invoiceTemplateId => ({
  type: GET_DETAIL_INVOICE_TEMPLATE,
  payload: invoiceTemplateId,
});

export const getDetailInvoiceTemplateSuccess = data => ({
  type: GET_DETAIL_INVOICE_TEMPLATE_SUCCESS,
  payload: data,
});

export const getDetailInvoiceTemplateFail = error => ({
  type: GET_DETAIL_INVOICE_TEMPLATE_FAIL,
  payload: error,
});

// Get list invoice type
export const getListInvoiceType = (businessUnitId) => ({
  type: GET_LIST_INVOICE_TYPE,
  payload: { businessUnitId },
});

export const getListInvoiceTypeSuccess = data => ({
  type: GET_LIST_INVOICE_TYPE_SUCCESS,
  payload: data,
});

export const getListInvoiceTypeFail = error => ({
  type: GET_LIST_INVOICE_TYPE_FAIL,
  payload: error,
});
